import React, { useEffect } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor, greyBg, NECROPSY_STATE, white } from '../../../../theme/colors'
import { Button } from '../../../../components/Button'
import { useForm } from '../../../../hooks/useForm'
import { StateForm } from '../../../../context/Necropsy/types'

interface Props {
  onChange: (state: StateForm) => void
}

interface Values {
  selectedOption: null | StateForm
}

export const Filters = ({ onChange }: Props) => {
  const { values, onChangeValues } = useForm<Values>({
    selectedOption: null,
  })

  const onSelectedOption = (stateForm: StateForm) => {
    onChangeValues({
      name: 'selectedOption',
      value: values.selectedOption === stateForm ? null : stateForm,
    })
  }

  useEffect(() => {
    onChange(values.selectedOption)
  }, [values])

  return (
    <View style={style.container}>
      <Text style={style.title}>Filtros</Text>
      <View style={{ flexDirection: 'row', paddingVertical: 16, gap: 8 }}>
        <Button
          label='Enviado'
          onPress={() => onSelectedOption('sent')}
          customStyle={[
            style.sentButton,
            values.selectedOption === 'sent' && { backgroundColor: NECROPSY_STATE.sent },
          ]}
          labelStyle={[style.labelButton, values.selectedOption === 'sent' && { color: white }]}
          closeIcon={values.selectedOption === 'sent'}
        />

        <Button
          label='Sincronizando'
          onPress={() => onSelectedOption('sending')}
          customStyle={[
            style.synchronizingButton,
            values.selectedOption === 'sending' && {
              backgroundColor: NECROPSY_STATE.sending,
            },
          ]}
          labelStyle={[style.labelButton, values.selectedOption === 'sending' && { color: white }]}
          closeIcon={values.selectedOption === 'sending'}
        />

        <Button
          label='No enviado'
          onPress={() => onSelectedOption('pending')}
          customStyle={[
            style.unsentButton,
            values.selectedOption === 'pending' && { backgroundColor: NECROPSY_STATE.pending },
          ]}
          labelStyle={[style.labelButton, values.selectedOption === 'pending' && { color: white }]}
          closeIcon={values.selectedOption === 'pending'}
        />
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: {
    backgroundColor: greyBg,
    paddingTop: 24,
    paddingHorizontal: 24,
  },
  title: {
    color: corporateColor,
    fontSize: 16,
    fontWeight: '400',
  },
  labelButton: {
    color: corporateColor,
    fontSize: 15,
    fontWeight: '600',
  },
  sentButton: {
    backgroundColor: white,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    padding: 10,
    width: 'auto',
  },
  unsentButton: {
    backgroundColor: white,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    padding: 10,
    width: 'auto',
  },
  synchronizingButton: {
    backgroundColor: white,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    padding: 10,
    width: 'auto',
  },
})
